import React, { ChangeEvent, ReactNode, useEffect, useLayoutEffect, useRef, useState } from "react";
import { CoreValidatorFunction } from "./CoreValidations";

interface CoreSelectProps {
    label?: string;
    group?: string;
    name?: string;
    children?: ReactNode | undefined;
    value?: string | number;
    dictionary: { name: string, value: string };
    items: any[];
    onChange: (event?: CoreEventChange) => void | undefined;
    validations?: CoreValidatorFunction[];
    valueFormat?: "string" | "number";
    readonly?: boolean;
}


export const Coreselect = (
    {
        label,
        name = "",
        children,
        group = "",
        value,
        valueFormat = "string",
        dictionary = { name: "name", value: "value" },
        items = [],
        onChange,
        validations,
        readonly
    }: CoreSelectProps) => {

    const [errors, setErrors] = useState<string[]>([]);
    // current ref
    const elementRef = useRef<HTMLSelectElement>();
    const [haserrors, setHasErrors] = useState(false);

    const validate = (name: string, value: any) => {

        if (validations) {

            const results = validations.map(validation => validation(name, value)) || [];
            const newErrors = results.filter(r => !r.valid).map(r => r.error);

            dispatchValidation(results);
            // set errors
            setErrors(newErrors);
            setHasErrors(newErrors.length > 0);
        }
    }

    const dispatchValidation = (results: CoreValidatorResult[]) => {

        const validationEvent = new CustomEvent<CoreValidationResults>(
            "core-input-validation",
            { detail: { name, group, validationResults: results }, bubbles: true });

        // dispatch event to coreForm
        if(!elementRef || !elementRef.current) {
            console.log("Core Select null", name);
            return;
        }
        elementRef.current.dispatchEvent(validationEvent);
    }



    const onSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {

        let value: any = event.target.value;

        if (valueFormat == "number")
            value = parseInt(value);

        // dipatch on change to parent
        onChange && onChange({ name, value });

        //trigger validate
        validate(name, value);
    }

    useLayoutEffect(() => {

        setTimeout(() => validate(name || "", value), 20);

        return () => {
            //clean old errors
            dispatchValidation([]);
        }
    }, [])

    return (
        <div className="flex flex-column mb-2">
            <label className="px-2 text-sm m-0 text-gray-500" htmlFor={name}>{label}</label>
            <select
                id={name}
                className={`
                    p-2 
                    border-2 rounded 
                    ${readonly ? "bg-gray-100" : ""}
                    border-gray-300 
                    hover:border-gray-400 
                    text-sm 
                    focus:outline-none
                    active:border-green-600            
                    focus:border-green-600
                    focus:text-gray-800
                    text-gray-500
                    
                    ${haserrors && 'border-red-300 hover:border-red-400 '}
                    `}
                ref={elementRef}
                name={name}
                value={value}
                onChange={onSelectChange}
                style={{ pointerEvents: readonly ? "none" : "auto" }}
            >

                {items.map((item, index) => {
                    return (<option key={`${index}`} value={item[dictionary.value]}>{item[dictionary.name]}</option>)
                })}
            </select>

            {
                errors &&
                errors.map((error, i) => <label key={i} className="px-2 text-xs text-red-500 m-0" htmlFor={name}>{error}</label>)
            }
        </div >
    )

}